<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Buscar información de NSS</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'IMSS' }, { label: 'Buscar información de NSS' }]" />
    </div>
  </section>

  <section wrapper>
    <div [formGroup]="formUpload" class="page-section card">
      <div class="card-body d-flex flex-column gap-3">
        <div class="row">
          <div class="col-12 col-sm-4">
            <div class="flex flex-column gap-2">
              <p-inputMask formControlName="curp" placeholder="CURP" mask="******************" styleClass="w-100 h-50px"></p-inputMask>

              <small class="ps-2"><span class="text-danger">Requerido *</span></small>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <p-button label="Consultar" class="d-block h-50px" styleClass="h-100" [loading]="isSaving" (onClick)="consult()" [disabled]="this.formUpload.invalid" />
          </div>
        </div>
      </div>
    </div>

    <div class="page-section card">
      <div class="card-body p-0">
        <p-table #dt1 [value]="this.list" [rows]="25" [showCurrentPageReport]="true" [rowsPerPageOptions]="[25, 50, 100]" [paginator]="true" [globalFilterFields]="['curp']">
          <ng-template pTemplate="caption">
            <div class="d-flex align-items-stretch justify-content-between gap-2">
              <p-inputgroup>
                <p-iconfield class="w-100">
                  <p-inputicon styleClass="pi pi-search" />
                  <input type="text" pInputText [(ngModel)]="searchValue" (input)="dt1.filterGlobal(searchValue, 'contains')" placeholder="Buscar por CURP." class="w-100 h-50px rounded-end-0" />
                </p-iconfield>
                <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
                  <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
                </p-inputgroup-addon>
              </p-inputgroup>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>CURP</th>
              <th>NSS</th>
              <th>ESTATUS</th>
              <th colspan="2">FECHA</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td class="text-nowrap">{{ item.curp }}</td>

              <!-- NSS -->
              @if (item.status === 'SUCCESS') {
              <td class="text-nowrap">{{ item.details.NSS }}</td>
              } @else {
              <td class="text-nowrap"></td>
              }

              <!-- ESTATUS -->
              @if (item.status === 'SUCCESS') {
              <td class="text-nowrap">
                <p-tag value="OK" severity="success" class="fw-normal cursor-pointer" />
              </td>
              } @else {
              <td class="text-nowrap">
                <p-tag value="Error" severity="danger" class="fw-normal cursor-pointer" (click)="showError(item.message)" />
              </td>
              }

              <td class="text-nowrap" style="width: 200px !important">{{ item.dateCreated | date : "longDate" }}</td>

              <td class="text-nowrap" style="width: 100px !important">
                <p-button label="Ver detalles" size="small" (click)="viewDetails(item)" />
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="6">No se encontraron registros.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <p-dialog
      header="Detalles"
      [(visible)]="statusModalDetails"
      [modal]="true"
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
      [style]="{ width: '50vw' }"
      [draggable]="false"
      [resizable]="false"
      [dismissableMask]="true"
    >
      <div class="relative d-flex flex-column gap-2">
        <div class="d-flex gap-2 align-items-center">
          <span style="width: 180px">Verificado:</span>
          @if (itemDetails.details?.IND_VERIFICADO) {
          <span><p-tag severity="success" value="Verificado" /></span>
          } @else {
          <span><p-tag severity="danger" value="Sin verificar" /></span>
          }
        </div>

        <div class="d-flex gap-2 align-items-center">
          <span style="width: 180px">NSS:</span>
          <span>{{ itemDetails.details?.NSS }}</span>
        </div>

        <div class="d-flex gap-2 align-items-center">
          <span style="width: 180px">CURP:</span>
          <span>{{ itemDetails.details?.CURP }}</span>
        </div>

        <div class="d-flex gap-2 align-items-center">
          <span style="width: 180px">NOMBRE COMPLETO:</span>
          <span>{{ itemDetails.details?.NOMBRE }} {{ itemDetails.details?.PRIMER_APELLIDO }} {{ itemDetails.details?.SEGUNDO_APELLIDO }}</span>
        </div>

        <div class="d-flex gap-2 align-items-center">
          <span style="width: 180px">FECHA DE NACIMIENTO:</span>
          <span>{{ itemDetails.details?.FECHA_NACIMIENTO | date : "longDate" }}</span>
        </div>

        <div class="d-flex gap-2 align-items-center">
          <span style="width: 180px">SEXO:</span>
          <span>{{ itemDetails.details?.SEXO === "H" ? "HOMBRE" : "MUJER" }}</span>
        </div>

        <div class="d-flex gap-2 align-items-center">
          <span style="width: 180px">CORREO ELECTRÓNICO:</span>
          <span>{{ itemDetails.details?.CORREO }}</span>
        </div>

        <div class="d-flex gap-2 align-items-center">
          <span style="width: 180px">ÚLTIMA MODIFICACIÓN:</span>
          <span>{{ itemDetails.details?.FEC_MODIFICA | date : "longDate" }}</span>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="Error"
      [(visible)]="statusModalError"
      [modal]="true"
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
      [style]="{ width: '50vw' }"
      [draggable]="false"
      [resizable]="false"
      [dismissableMask]="true"
    >
      <div class="text-danger">{{ itemError }}</div>
    </p-dialog>
  </section>
</backbone>
